import { RG_TYPE } from '../../types/rg-type.js';
import { DefaultCeiling } from './default-ceiling.js';
import { DefaultFloor } from './default-floor.js';
import { DefaultWall } from './default-wall.js';

const DefaultCorridor = {
    type: RG_TYPE.Corridor,
    color: '#EAEAEA',
    size: [3.0, 2.5, 2.0],
    anchor: [0.5, 0, 0.5],
    name: 'corridor',
    data: { level: -1, levelId: '', tendonID: '' },
    children: [
        { ...DefaultWall, pos: [0, 0, -3] },
        { ...DefaultWall, pos: [0, 0, 3], rot: [180, 0, 180] },
        { ...DefaultWall, pos: [-3, 0, 0], rot: [0, 90, 0] },
        { ...DefaultWall, pos: [3, 0, 0], rot: [0, -90, 0] },
        { ...DefaultCeiling },
        { ...DefaultFloor }
    ]
};

export { DefaultCorridor };
//# sourceMappingURL=default-corridor.js.map
